import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  constructor(private GenericUtility: GenericUtilityService) { }

  getProvider(practice_code: any, patient_Account: any) {
    return this.GenericUtility.ApiGetMethodTalkphr('TalkCheckinPhaseTwo/GetProvider?PracticeCode=' + practice_code + '&patientAcount=' + patient_Account);
  }

  getAppointmentReasons(practice_code: string, patient_account: string) {

    return this.GenericUtility.ApiGetMethodTalkphr('TalkCheckinPhaseTwo/AppointmentReasons?PracticeCode=' +
      practice_code + '&PatientAccount=' + patient_account);

  }

  getAppointmentTimeSlots(data: any) {

    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "GettimeSlotsTalkCheckin", data);

  }

  addScheduleAppointment(data: any) {

    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "AddAppointment", data);

  }

  getAppointmentDetails(practice_code: any, patient_Account: any, appoint_id: any) {

    return this.GenericUtility.ApiGetMethodTalkphr('TalkCheckinPhaseTwo/GetAppointmentDetailsByID?PracticeCode=' + practice_code + "&PatientAccount=" + patient_Account + "&ApptID=" + appoint_id);

  }

  getCheckinSMSDetails(practice_code: any, patient_Account: any) {

    return this.GenericUtility.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/CheckinTimeSettings?PracticeCode=" + practice_code + "&PatientAccount=" + patient_Account);

  }
}
